/** Path constants — never hardcode a route string. */
export const ROUTES = {
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verify: '/verify',
  createStore: '/create-store',

  admin: {
    root: '/admin',
    categories: '/admin/categories',
    suppliers: '/admin/suppliers',
    products: '/admin/products',
    productNew: '/admin/products/new',
    product: (id: string) => `/admin/products/${id}`,
    settings: '/admin/settings',
    stock: '/admin/stock',
    stockProduct: (id: string) => `/admin/stock/products/${id}`,
  },

  notFound: '/404',
  noAccess: '/no-access',
} as const;
